import React from 'react'
import { useMediaQuery } from 'react-responsive'
import Button from 'shared/ui/Button/Button'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrow_short_right.svg'
import s from './styles/ContentFiltersPanel.module.scss'

export default function ContentFiltersPanel({
	title = 'Filters',
	subtitle,
	icon,
	onClose,
	children,
}) {
	const isMobile = useMediaQuery({ query: '(max-width: 1023px)' })

	return (
		<div className={s.root}>
			<div className={s.header}>
				<div className={s.title}>
					{icon && <span className={s.title__icon}>{icon}</span>}
					<span className={s.title__text}>{title}</span>
				</div>

				<Button
					variant="ghost"
					className={s.close}
					onClick={onClose}
					ariaLabel="Close"
				>
					{isMobile ? (
						'×'
					) : (
						<span className={s.close__icon}>
							<ArrowIcon />
						</span>
					)}
				</Button>
			</div>

			{subtitle && (
				<div className={s.section}>
					<span className={s.subtitle}>{subtitle}</span>
				</div>
			)}

			{children}
		</div>
	)
}
